import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_5: FaireProductEntity = {
  token: "atc_refined_moma_5",
  type: "product",
  name: "Porcelain Tea Cup Collection",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e77bd1611c62bce6b10680bcd2f4d7e1f09e8cd3bbf3acacf00225ca7c978e89.webp",
  priceDollars: 32,
  msrpDollars: 54,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
